import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-2",
  "use": "menu-2-usage",
  "viewBox": "0 0 20 19.61",
  "content": "<symbol viewBox=\"0 0 20 19.61\" id=\"menu-2\"><title>menu-2</title><path d=\"M10.89,13.15\" transform=\"translate(0 -0.19)\" /><path d=\"M19.93,5.1\" transform=\"translate(0 -0.19)\" fill=\"#242424\" /><path d=\"M20,13.8c0,.35-.18.64-.41.64H.41c-.22,0-.41-.29-.41-.64V11.32c0-.35.18-.64.41-.64H19.59c.22,0,.41.29.41.64Z\" transform=\"translate(0 -0.19)\" /><path d=\"M20,19.17c0,.35-.18.64-.41.64H.41c-.22,0-.41-.29-.41-.64V16.69c0-.35.18-.64.41-.64H19.59c.22,0,.41.29.41.64Z\" transform=\"translate(0 -0.19)\" /><path d=\"M19.59.19H.41A.41.41,0,0,0,0,.6V8.69a.41.41,0,0,0,.41.41H19.59A.41.41,0,0,0,20,8.69V.6A.41.41,0,0,0,19.59.19ZM8.13,4.14a.41.41,0,0,1-.41.41H2.32a.41.41,0,0,1-.41-.41V2.56a.41.41,0,0,1,.41-.41H7.73a.41.41,0,0,1,.41.41Z\" transform=\"translate(0 -0.19)\" /><path d=\"M8.13,4.14\" transform=\"translate(0 -0.19)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-2.svg
// module id = vgP0
// module chunks = 264